export default __webpack_public_path__ + "static/media/more_coffee.aab848c5.svg";